import React from 'react';
import { HeroSectionV2 } from '../components/HeroSectionV2';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPageV2() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-1160">
      <HeroSectionV2 data-id="element-1161" />
      <PainSection data-id="element-1162" />
      <TruthSection data-id="element-1163" />
      <ProductPresentation data-id="element-1164" />
      <ContentBreakdown data-id="element-1165" />
      <BenefitsSection data-id="element-1166" />
      <TestimonialsSection data-id="element-1167" />
      <ForYouSection data-id="element-1168" />
      <GuaranteeSection data-id="element-1169" />
      <BonusSection data-id="element-1170" />
      <ValueStack data-id="element-1171" />
      <FAQSection data-id="element-1172" />
      <ImpactPhrases data-id="element-1173" />
      <Footer data-id="element-1174" />
    </div>;
}